import { atom } from 'recoil';

export const devOptionsState = atom<Record<string, React.ReactNode>>({
  key: 'sd:devOptions',
  default: {}
});
